<template>
  <div class="d-flex align-items-center gap-2 py-2 me-4" style="max-width: 95vw;">
    <div v-if="establishments" class="d-flex align-items-center gap-1">
      <a href="#" class="arrow-establishment">
        <i class="d-inline-block text-primary icon-20 bi-chevron-left"
           @click.prevent="$emit('previousEstablishment')"></i>
      </a>
      <DropDownSearch
          :items="establishments"
          :currentValue="establishment"
          :showSearchField="true"
          defaultLabel="Etab."
          @dropdownClick="$emit('update:establishment', $event)"
      />
      <a href="#" class="arrow-establishment">
        <i class="d-inline-block text-primary icon-20 bi-chevron-right"
           @click.prevent="$emit('nextEstablishment')"></i>
      </a>
    </div>
    <div>
      <DropDownSearch
          :items="sentiments"
          :currentValue="sentiment"
          :showSearchField="false"
          defaultLabel="Sentiment"
          @dropdownClick="$emit('update:sentiment', $event)"
      />
    </div>
    <div>
      <DropDownSearch
          v-if="platforms"
          :items="platforms"
          :currentValue="platform"
          :showSearchField="true"
          defaultLabel="Plateforme"
          @dropdownClick="$emit('update:platform', $event)"
      />
    </div>
    <div>
      <DropDownSearch
          :items="status_set"
          :currentValue="status"
          :showSearchField="false"
          defaultLabel="Statut"
          @dropdownClick="$emit('update:status', $event)"
      />
    </div>
    <div>
      <DropDownSearch
          :items="tag_set"
          :currentValue="tag"
          :showSearchField="false"
          defaultLabel="Tag"
          @dropdownClick="$emit('update:tag', $event)"
      />
    </div>
    <div class="d-flex align-items-center justify-content-start gap-2">
      <DateInput
          :modelValue="dateBegin"
          label="Date début"
          format="DD/MM/YYYY"
          @change="$emit('update:dateBegin', $event)"
      />
      <DateInput
          :modelValue="dateEnd"
          label="Date fin"
          format="DD/MM/YYYY"
          @change="$emit('update:dateEnd', $event)"
      />
    </div>
    <div>
      <DropDownSearch
          v-if="showConsultant && Array.isArray(consultants)"
          :items="consultants"
          :currentValue="consultant"
          :showSearchField="false"
          defaultLabel="Consultant"
          shownKey="fullname"
          @dropdownClick="$emit('update:consultant', $event)"
      />
    </div>
    <div>
      <UiSwitch
          v-if="showConsultant"
          :modelValue="classified"
          label="Classé"
          @change="$emit('update:classified', $event)"
      />
    </div>
    <div class="btn-group btn-group-sm my-0" v-if="padAndLogos">
      <button type="button"
              @click="$emit('toggle-pad')"
              class="btn btn-sm btn-primary my-0">
        <span>
          <i :class="[showPad ? 'bi-eye-slash' : 'bi-eye', 'icon-14 me-2']"></i>
          {{ showPad ? 'Masquer' : 'Afficher' }} le pad
        </span>
      </button>
      <button type="button"
              @click="$emit('toggle-logos')"
              class="btn btn-sm btn-outline-primary my-0">
        <span>
          <i :class="[showPad ? 'bi-eye-slash' : 'bi-eye', 'icon-14 me-2']"></i>
          {{ showPad ? 'Masquer' : 'Afficher' }} IA
        </span>
      </button>
    </div>
    <div class="ms-auto">
      <a href="#" class="position-relative d-inline-flex" data-bs-toggle="modal" data-bs-target="#stat-modal-consult">
        <PourcentageStatTag :pourcentage="pourcentageStatTagValue"/>
      </a>
    </div>
  </div>

</template>


<script>
import DropDownSearch from '@/components/ui/DropDownSearch.vue';
import DateInput from '@/components/ui/DateInput.vue';
import UiSwitch from '@/components/ui/Switch.vue';
import PourcentageStatTag from '@/components/PourcentageStatTag.vue';

export default {
  name: 'FilterBar',
  components: {DropDownSearch, DateInput, UiSwitch, PourcentageStatTag},
  props: {
    establishments: Array,
    establishment: Object,
    sentiments: Array,
    sentiment: Object,
    platforms: {
      type: [Array, null],
      default: () => []
    },
    platform: Object,
    status_set: Array,
    status: Object,
    tag_set: Array,
    tag: Object,
    dateBegin: [String, Date, null],
    dateEnd: [String, Date, null],
    consultants: {
      type: [Array, null],
      default: () => []
    },
    consultant: Object,
    classified: Boolean,
    pourcentageStatTagValue: Number,
    showPad: Boolean,
    showLogos: Boolean,
    padAndLogos: Boolean,
    showConsultant: Boolean,
  }
};
</script>

<style scoped>
.icon-20 {
  font-size: 20px;
}
</style>
